export default function getEnvParam( envParam ) {
 return (window.ENV[envParam]) ? window.ENV[envParam] : process.env[envParam];
}
